import MessageToAgent from '../../forms/MessageToAgent';
import centredForm from '../components/centredForm';

export default centredForm(MessageToAgent, '', 1200);



// WEBPACK FOOTER //
// ./src/view/scenes/MessageToAgent/index.js